import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "./Reveal";

const BG_IMG =
  "https://images.pexels.com/photos/35696867/pexels-photo-35696867.jpeg";

const PRINCIPLES = [
  {
    numeral: "I",
    title: "THE RIGHT PEOPLE.",
    words: ["Talent", "Character", "Potential"],
    testid: "approach-principle-people",
  },
  {
    numeral: "II",
    title: "THE RIGHT ROOM.",
    words: ["Context", "Connections", "Conversations"],
    testid: "approach-principle-room",
  },
  {
    numeral: "III",
    title: "THE RIGHT DEAL.",
    words: ["Value", "Structure", "Long Term"],
    testid: "approach-principle-deal",
  },
];

export const Approach = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const bgY = useTransform(scrollYProgress, [0, 1], ["-6%", "6%"]);

  return (
    <section
      id="approach"
      ref={ref}
      className="relative overflow-hidden py-28 sm:py-40"
      data-testid="approach-section"
    >
      <motion.div
        style={{ y: bgY }}
        aria-hidden="true"
        className="absolute inset-y-[-10%] left-0 hidden w-[38%] opacity-[0.14] lg:block"
      >
        <div
          className="h-full w-full"
          style={{
            backgroundImage: `url(${BG_IMG})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            WebkitMaskImage:
              "linear-gradient(to left, transparent 0%, black 55%)",
            maskImage: "linear-gradient(to left, transparent 0%, black 55%)",
          }}
        />
      </motion.div>

      <div className="relative mx-auto max-w-[1600px] px-6 sm:px-10">
        <Reveal>
          <p className="dealer-eyebrow">THE DEALER APPROACH</p>
        </Reveal>

        <div className="mt-16 grid gap-16 md:grid-cols-3 md:gap-10 lg:gap-16">
          {PRINCIPLES.map((p, i) => (
            <Reveal key={p.numeral} delay={0.1 + i * 0.12}>
              <div data-testid={p.testid} className="group">
                <span className="font-serif text-sm italic text-dealer-burgundybright">
                  {p.numeral}
                </span>
                <div className="dealer-rule my-6" />
                <h3 className="font-serif text-2xl leading-snug tracking-tight text-dealer-ivory sm:text-3xl">
                  {p.title}
                </h3>
                <ul className="mt-8 space-y-3">
                  {p.words.map((w) => (
                    <li
                      key={w}
                      className="flex items-center gap-4 font-sans text-[11px] font-medium tracking-[0.3em] text-dealer-silver"
                    >
                      <span className="block h-px w-5 bg-dealer-burgundy transition-[width] duration-500 group-hover:w-8" />
                      {w.toUpperCase()}
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
